import React from "react";

import "./Header.css";

const Header = () => {
  return (
    <header className="header-main no-print" role="header">
      <div className="background-image">
        <h1 className="header-text">How Self-Aware Are You?</h1>
      </div>
    </header>
  );
};

export default Header;
